module.exports = __webpack_public_path__ + "img/clinica los andes.1b39aead.png";